<template>
  <div :class="shape.value == 'Heart' ? 'heart' : ''" class="designer-right">
    <img :src="backgroundImage" alt="Memorial" class="background" />
    <div class="inscription" v-html="inscription_text"></div>
    <!--<textarea
      class="txt-preview"
      :class="introduction_size"
      id="previewIntro"
      disabled
      type="text"
      v-model="introduction"
      :style="{ fontFamily: introduction_font }"
    ></textarea>
    <textarea
      class="txt-preview"
      :class="name_size"
      id="previewName"
      disabled
      type="text"
      v-model="name"
      :style="{ fontFamily: name_font }"
    ></textarea>
    <textarea
      class="txt-preview"
      :class="known_size"
      id="previewKnown"
      disabled
      type="text"
      v-model="known"
      :style="{ fontFamily: known_font }"
    ></textarea>
    <textarea
      class="txt-preview"
      :class="dates_size"
      id="previewDates"
      disabled
      type="text"
      v-model="dates"
      :style="{ fontFamily: dates_font }"
    ></textarea>
    <textarea
      class="txt-preview"
      :class="sentiment_size"
      id="previewSentiment"
      disabled
      type="text"
      v-model="sentiment"
      :style="{ fontFamily: sentiment_font }"
    ></textarea>
    <textarea
      class="txt-preview"
      :class="closing_size"
      id="previewClosing"
      disabled
      type="text"
      v-model="closing"
      :style="{ fontFamily: closing_font }"
    ></textarea>-->
    <div class="disclaimer">
      This image is for illustrative purposes only. If you have chosen a product from our brochure or uploaded a
      photograph, we will use that when creating your accurate visualisation.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: "",
      introduction: "",
      introduction_size: "Medium",
      introduction_font: "Helvetica Condensed Medium",
      name: "",
      name_size: "Medium",
      name_font: "Helvetica Condensed Medium",
      known: "",
      known_size: "Medium",
      known_font: "Helvetica Condensed Medium",
      dates: "",
      dates_size: "Medium",
      dates_font: "Helvetica Condensed Medium",
      sentiment: "",
      sentiment_size: "Medium",
      sentiment_font: "Helvetica Condensed Medium",
      closing: "",
      closing_size: "Medium",
      closing_font: "Helvetica Condensed Medium"
    }
  },
  props: ["inscription_text"],
  computed: {
    shape() {
      return this.$store.state.style.shape || {}
    },
    backgroundImage: function() {
      var image = "heart.jpg"
      switch (this.shape.value) {
        case "Ogee":
          image = "ogee.jpg"
          break
        case "Camber":
          image = "camber.jpg"
          break
        case "HalfOgee":
          image = "half-ogee.jpg"
          break
        case "Centre":
          image = "gothic.jpg"
          break
        case "CrematoriumTablet":
          image = "tablet.jpg"
          break
      }
      return "/images/shapes/" + image
    }
  }
}
</script>

<style scoped>
.designer-right {
  text-align: right;
  position: relative;
}

.inscription {
  position: absolute;
  z-index: 10;
  position: absolute;
  width: 55%;
  left: 22.5%;
  top: 12%;
  overflow: hidden;
  line-height: 0.8;
}

.txt-preview {
  border: 0 !important;
  background: transparent !important;
  text-align: center;
  position: absolute;
  z-index: 10;
  font-size: 1.6rem;
  transition: all 0.3s;
  position: absolute;
  width: 55%;
  left: 22.5%;
  resize: none;
  height: 5rem;
  overflow: hidden;
}

.txt-preview.Small {
  font-size: 1.2rem;
}

.txt-preview.Large {
  font-size: 2rem;
}

#previewIntro {
  top: 22%;
}

#previewName {
  top: 30%;
}

#previewKnown {
  top: 38%;
}

#previewDates {
  top: 46%;
}

#previewSentiment {
  top: 54%;
}

#previewClosing {
  top: 62%;
}

.heart #previewIntro {
  top: 12%;
}

.heart #previewName {
  top: 20%;
}

.heart #previewKnown {
  top: 28%;
}

.heart #previewDates {
  top: 36%;
}

.heart #previewSentiment {
  top: 44%;
}

.heart #previewClosing {
  top: 52%;
}

.disclaimer {
  text-align: left;
  font-size: 1.2rem;
  opacity: 0.6;
}
@media screen and (min-width: 1051px) {
  .designer-right {
    margin-top: 1rem;
  }
}
@media screen and (max-width: 1050px) {
  .designer-right {
    margin-top: 3rem;
    text-align: left;
  }
  .disclaimer {
    text-align: center;
    padding-left: 0%;
  }
}
@media screen and (max-width: 550px) {
  .txt-preview {
    font-size: 1.3rem;
  }

  .txt-preview.Small {
    font-size: 1rem;
  }

  .txt-preview.Large {
    font-size: 1.5rem;
  }
}
</style>
